module.exports = "/images/mail-envelope.svg?52cc434226fb21ecb9fe8992f0dd5bba";